/* global INBOX */

// Inbox profile images
var inx   = require('inx'),
    isStorageAvailable = require('../utils').isStorageAvailable;

// TODO: Refactor this
INBOX.namespace('classes.Avatar', function () {
    var iName         = '.inx-profile__thumb',
        instance      = null,
        spacerImgUrl  = location.protocol + '//' + location.host + '/assets/com/img/spacer.gif',
        isLSAvailable = isStorageAvailable('localStorage'),
        avatarIsSetArr   = []
    ;

    function doReload(url) {
        var deferred = $.Deferred();
        if (mustReloadCache()) {
            img.reloadCached(url).always(function () {
                // console.log('cache reloaded! Fetching img...');
                img.fetch(url).then(deferred.resolve, deferred.reject);
            });
        }
        else {
            img.fetch(url).then(deferred.resolve, deferred.reject);
        }
        return deferred.promise();
    }

    function mustReloadCache() {
        if (isLSAvailable) {
            //todo this probably does not work if multiple avatars are on page (linked accounts)

            return (localStorage.reloadCachedImg === 'true') ? true : false;
        }
        return true;
    }

    // Set redirect url in case of empty avatar
    function setLinkToAvatar(atag, avatarInstance) {
        avatarInstance.isSet.done(function (type) {
            if (type !== 'default') {
                return;
            }
            $(atag.linkId).attr('href', atag.addUrl);
        });
    }

    var img = {
        // Spacer dimensions are: 1 x 1px
        isSpacer(img) {
            return (img.height < 2 && img.width < 2);
        },
        // Fetch image
        fetch(iSrc) {
            const deferred = $.Deferred();

            if (!iSrc) {
                deferred.reject();
            }
            else {
                const pic = new Image();
                pic.addEventListener('load', function () {
                    // console.log('Image loaded: %s', this.src);
                    if (img.isSpacer(this)) {
                        // console.info('image is spacer');
                        deferred.reject();
                    }
                    else {
                        deferred.resolve();
                    }
                });
                pic.addEventListener('error', function () {
                    // console.warn('Failed to load: %s', this.src);
                    deferred.reject();
                });
                pic.src = iSrc;
            }
            return deferred.promise();
        },
        getUrl($img) {
            if (typeof($img) !== 'object' || $img.length < 1) {
                return false;
            }
            const url = $img.data('src');
            if (url.trim().length < 1) {
                return false;
            }
            return url.trim();
        },
        // Reload img from server
        reloadCached(url) {
            url = url || instance.imgUrl;
            let deferred  = $.Deferred(),
                firstLoad = true,
                iframe;

            function loadCallback() {
                if (firstLoad) {
                    firstLoad = false;
                    iframe.src = url; // Avoid 'Permission denied in IE 11
                    iframe.contentWindow.location.reload(true);
                    if (isLSAvailable) {
                        localStorage.reloadCachedImg = 'false';
                    }
                }
                else {
                    if (iframe.parentNode) {
                        iframe.parentNode.removeChild(iframe);
                    }
                    deferred.resolve();
                }
            }

            iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
            iframe.addEventListener('load', loadCallback, false);
            iframe.addEventListener('error', loadCallback, false);
            iframe.src = url;
            return deferred.promise();
        },
        /** Set avatar or default image
            * @param {object} iObj Contains img name, type and url
            *
            */
        set(iObj) {
            let name = (iObj ? iObj.iName : false) || iName,
                url  = (iObj ? iObj.iUrl  : false) || spacerImgUrl,
                type = (iObj ? iObj.iType : false) || 'default';

            switch (type) {
            case 'default':
                if ($(name).data('fallback')) {
                    $(name).attr('src', $(name).data('fallback')); // new design
                } else {
                    $(name).replaceWith('<span class="ifi-profile" />'); // old design
                }

                break;
            default:
                $(name).css({'background-image': 'url(' + url + ')', 'background-size': '100%'});
            }
            return type;
        }
    };

    /**
    * Constructor for avatar checking/setting/reloading
    * @this Avatar
    * @constructor
    * @param {string} name Avatar img selector name (class || id)
    */
    var Avatar = function (name) {
        iName = name || iName;

        // Current URL of avatar
        this.imgUrl = img.getUrl($(iName));
        this.iNameX = iName;
        // Profile img set status promise

        this.isSet = avatarIsSetArr[iName] = $.Deferred();

        this.check = () => {
            doReload(this.imgUrl).done(() =>  {
                avatarIsSetArr[iName].resolve(img.set({
                    iType: 'setByUser',
                    iName: this.iNameX,
                    iUrl: this.imgUrl
                }));
            }).fail(() => {
                avatarIsSetArr[iName].resolve(img.set({
                    iType: 'default',
                    iName: this.iNameX
                }));
            });
            return this;
        };

        this.reload = img.reloadCached;

        this.removeIt = img.set;
    };

    return function (params) {
        const { user } = inx.params;
        instance = new Avatar(params);
        // Redirect Link for empty profile img
        if (user && user.profileImg) {
            setLinkToAvatar(user.profileImg, instance);
        }
        return instance;
    };
});
